// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-02T15:53:03.164Z
// Property: Woodside Place Apartments (ID: 6767906449167382)
// Collections: 9 amenities, 6 floorplans (live), 18 photos, 40 POIs, 1 reviews, 2 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167382",
  "property_external_id": "4984628",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/woodside-place-apartments-columbus-oh/w0gge2j/",
  "property_google_business_url": "https://www.google.com/maps/place/Woodside+Place+Rental+Community/data=!4m2!3m1!1s0x0:0xcbcca311d0e1b883?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "4984628",
  "property_status": null,
  "property_slug": "woodside-place-apartments",
  "property_name": "Woodside Place Apartments",
  "property_website_url": "https://www.woodsideplaceapartments.com/",
  "property_domain": "https://www.woodsideplaceapartments.com/",
  "property_address": "3444 Tivoli Ct",
  "property_full_address": "3444 Tivoli Ct, Gahanna, OH 43230",
  "property_address_1": "3444 Tivoli Ct",
  "property_address_2": null,
  "property_address_city": "Gahanna",
  "property_address_state": "OH",
  "property_address_zip_full": "43230-5054",
  "property_address_zip": "43230",
  "property_address_country": "US",
  "property_address_county": "Franklin County",
  "property_neighborhood_address": "Wexmoor",
  "property_address_latitude": "40.0427421",
  "property_address_longitude": "-82.90140559999999",
  "property_email": "cbw@dietzpropertygroup.com",
  "property_phone": "(614) 476-0036",
  "property_call_tracking_phone": "614-476-0036",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Woodside Place Apartments in Gahanna, OH, where comfort meets convenience. Choose from spacious one and two-bedroom layouts featuring private entrances, stylish bay windows, and finished basements. Enjoy modern amenities like in-unit washers, air conditioning, and 24-hour emergency maintenance. Your ideal home awaits—browse our availability today!",
  "property_long_description": "Welcome to Woodside Place Apartments, where comfort and convenience meet in the heart of Gahanna, OH! Our stunning community offers a variety of thoughtfully designed floor plans, including spacious one and two-bedroom apartments to suit your lifestyle. Each unit features modern amenities, such as bay windows or sliding glass doors leading to your own private patio, perfect for enjoying the fresh air.\n\nAt Woodside Place, we prioritize your comfort and peace of mind. Enjoy 24-hour emergency maintenance and on-site assistance to ensure that your home is always running smoothly. Our apartments come equipped with essential amenities, including a washer and dryer, air conditioning, high-speed internet access, and fully equipped kitchens featuring a refrigerator, range, and dishwasher.\n\nWith select units offering finished basements and family rooms, you can create the perfect space for relaxation or entertaining. Our community is located within the highly-rated Gahanna school district, making it an ideal choice for families. Take advantage of our rental housing discount program and experience the benefits of living in a friendly and supportive neighborhood.\n\nDiscover the alluring charm of Woodside Place Apartments, where you'll find private entrances and a variety of flooring options, including tile and carpet. Whether you’re enjoying a cozy night in or soaking up the sun on your patio, this community is designed for your enjoyment.\n\nFind your new home today—browse our availability or schedule a tour to visit our exceptional community! Don’t miss the opportunity to experience all that Woodside Place has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
    "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
    "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
    "width": 1190,
    "height": 794
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "112",
  "property_year_built": "1986",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.32142857142857",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "We allow Cats and Dogs.",
  "property_pet_policy_description": "We allow Cats and Dogs.",
  "property_petpolicy_info": "Pet Policy Type: Cat, Dogs\nPet Policy: We allow Cats and Dogs. Limit of 2 pets per household. There is a $250 pet fee per pet and $35/mo pet rent per month. Breed restrictions apply",
  "property_online_leasing_url": "https://oll-leasing.loftliving.com/oll/?siteId=4984628",
  "property_resident_portal_url": "https://woodsideplace.loftliving.com/login",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc020-e7e6-72fa-a857-26690b95b694.webp",
  "property_primary_logo_media": {
    "alt_text": "Woodside Place Apartment Homes logo",
    "public_id": "019dc020-e7e6-72fa-a857-26690b95b694",
    "storage_key": "property/6767906449167382/019dc020-e7e6-72fa-a857-26690b95b694.webp",
    "width": 600,
    "height": 263
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc022-36e5-77c7-bc6e-9e36f43e043b.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019dc022-36e5-77c7-bc6e-9e36f43e043b",
    "storage_key": "property/6767906449167382/019dc022-36e5-77c7-bc6e-9e36f43e043b.webp",
    "width": 600,
    "height": 263
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc022-2e2b-76ab-85c6-d58c820e5f71.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019dc022-2e2b-76ab-85c6-d58c820e5f71",
    "storage_key": "property/6767906449167382/019dc022-2e2b-76ab-85c6-d58c820e5f71.webp",
    "width": 600,
    "height": 263
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#0AB38A",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - 925",
  "property_sqft_min": "650",
  "property_sqft_max": "925",
  "property_price_range": "1399",
  "property_price_min": null,
  "property_price_max": "1399",
  "property_available_units": 3,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJN1j4JtFhOIgRg7jh0BGjzMs",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/woodside-place-rental-community-columbus",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Woodside Place Apartments",
  "property_home_romance_title": "Embrace a Life of Love and Comfort in Your New Home",
  "property_home_amenities_blurb": "At Woodside Place Apartments in Gahanna, OH, find your perfect retreat with spacious one and two-bedroom floor plans. Enjoy the comfort of private entrances, finished basements, and modern kitchens with essential appliances. With on-site maintenance and a vibrant community, your ideal home awaits—discover your sanctuary today!",
  "property_home_floorplans_blurb": "At Woodside Place Apartments in Gahanna, OH, your ideal home awaits. Choose from spacious one and two-bedroom layouts tailored to enhance your lifestyle. Enjoy modern amenities and inviting community spaces. Browse our available apartment homes today and take the first step toward your new sanctuary in Gahanna!",
  "property_home_gallery_blurb": "At Woodside Place Apartments in Gahanna, OH, your ideal home awaits. Choose from thoughtfully designed one- and two-bedroom layouts featuring private entrances, bay windows, and finished basements. Enjoy modern amenities like high-speed internet, included washer/dryer, and 24-hour emergency maintenance. Picture yourself living here—comfort and convenience are just a visit away!",
  "property_home_neighborhood_blurb": null,
  "property_home_reviews_blurb": "At Woodside Place Apartments in Gahanna, OH, our residents love the exceptional value we offer. With features like cozy fireplaces and detached garages in one-bedroom townhouses, it’s no wonder they say, “Great apartment for the price.” Experience serene living and find out what our community members have to say!",
  "property_neighborhood_blurb": null,
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Woodside Place Apartments in Gahanna, OH, experience the perfect blend of comfort and convenience. Choose from thoughtfully designed one and two-bedroom layouts with private entrances, finished basements, and inviting outdoor spaces. Enjoy on-site maintenance, modern kitchens, and high-speed internet—making your life effortlessly enjoyable. Explore our amazing community amenities today!",
  "property_applynow_blurb": "At Woodside Place Apartments in Gahanna, our thoughtfully designed one and two-bedroom floor plans provide the perfect blend of comfort and convenience. Enjoy private entrances, peaceful patios, and amenities like 24-hour emergency maintenance and in-home laundry. Start your journey to a cozy home—lease online today and elevate your lifestyle!",
  "property_contactus_blurb": "At Woodside Place Apartments in Gahanna, OH, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Each space combines comfort and functionality, creating the perfect sanctuary. Have questions? Reach out to our friendly leasing team today and find the perfect home for you!",
  "property_faqs_blurb": "At Woodside Place Apartments in Gahanna, OH, choose from thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Got questions? Our FAQs page is your go-to resource for insights into our welcoming community. Delve into the details and make your next move with confidence!",
  "property_floorplans_blurb": "At Woodside Place Apartments in Gahanna, OH, your ideal home awaits. Choose from stylish one and two-bedroom layouts designed to complement your lifestyle. With an array of floor plans, each space offers comfort and functionality. Browse our available apartments today and secure your perfect sanctuary in our vibrant community!",
  "property_gallery_blurb": "At Woodside Place Apartments in Gahanna, OH, imagine your life surrounded by modern comforts and serene spaces. With one and two-bedroom floor plans that feature bay windows, private entrances, and finished basements, your perfect home awaits. Check out our photo gallery and picture yourself living here!",
  "property_interactivemap_blurb": "At Woodside Place Apartments in Gahanna, OH, comfort meets convenience. Choose from one and two-bedroom floor plans featuring private entrances and exceptional amenities, like in-unit washers, air conditioning, and inviting bay windows. Utilize our interactive community map to find your perfect home today and enjoy life with access to Gahanna Schools!",
  "property_pets_blurb": "At Woodside Place Apartments in Gahanna, OH, life blossoms amidst serene surroundings. Enjoy spacious living with your furry companions—cats and dogs are cherished members of our community. Experience the perfect blend of comfort and convenience, where modern amenities meet the peaceful embrace of nature, creating a welcoming home for all.",
  "property_referafriend_blurb": "At Woodside Place Apartments in Gahanna, OH, we believe great friends make the best neighbors! With spacious one- and two-bedroom floor plans designed to elevate your living experience, there's no better place to call home. Share the joy—refer a friend to our vibrant community today!",
  "property_residentaccess_blurb": "At Woodside Place Apartments in Gahanna, OH, our thoughtfully designed one and two-bedroom floor plans offer comfort and style. Enjoy seamless living with our resident portal, where you can easily pay rent, schedule maintenance, and manage your home from anywhere. Log in and elevate your lifestyle today!",
  "property_reviews_blurb": "At Woodside Place Apartments in Gahanna, OH, residents rave about the incredible value and peaceful atmosphere. One resident notes, “A fireplace and a detached garage in one bedroom townhouse is hard to come by at such a bargain.” Dive into our reviews to see why this community feels like home!",
  "property_created_at": "1775495749373",
  "property_scheduletour_blurb": "At Woodside Place Apartments in Gahanna, OH, our thoughtfully designed one and two-bedroom floor plans cater to every lifestyle. Experience the perfect blend of comfort and convenience. Ready to envision your new home? Schedule a tour and hear firsthand from our residents about what makes this community truly special!",
  "property_thankyou_blurb": "Thank you for reaching out to Woodside Place Apartments in Gahanna, OH! We’re excited to help you find your perfect home, whether it’s our cozy one-bedroom or spacious two-bedroom floor plans. Expect to hear from our team soon about your inquiry. Your dream apartment awaits!",
  "property_virtualtours_blurb": "At Woodside Place Apartments in Gahanna, OH, we offer a variety of thoughtfully designed floor plans, including cozy one-bedroom and spacious two-bedroom options. Experience the community’s charm and comfort from anywhere—take a virtual tour today and imagine your future home with us!",
  "property_copyright": "2026 All Rights Reserved. Woodside Place Apartments",
  "property_seo_title_home": "Woodside Place Apartments |  Apartments in Gahanna, OH",
  "property_seo_description_home": "Experience comfort at Woodside Place Apartments in Gahanna, OH. Choose from spacious one and two-bedroom layouts with modern amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Gahanna, OH Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Woodside Place Apartments in Gahanna, OH. Choose from stylish one and two-bedroom layouts that suit your lifestyle!",
  "property_seo_title_amenities": "Amenities | Gahanna, OH Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Woodside Place Apartments in Gahanna, OH! Enjoy private entrances, modern finishes, and a host of amenities designed for your lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Gahanna, OH",
  "property_seo_description_gallery": "Find your ideal home at Woodside Place Apartments in Gahanna, OH! Enjoy spacious layouts, community perks, and stunning views. Picture life here!",
  "property_seo_title_virtualtours": "Virtual Tours | Woodside Place Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Woodside Place Apartments in Gahanna, OH! Take a virtual tour of our inviting one and two-bedroom floor plans today and find your perfect home!",
  "property_seo_title_interactivemap": "Interactive Map | Woodside Place Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Woodside Place Apartments, Gahanna, OH—spacious layouts, modern amenities, and a vibrant community await!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Gahanna, OH",
  "property_seo_description_neighborhood": "Uncover Gahanna's hidden gems at Woodside Place Apartments! From local favorites to scenic spots, see what awaits just steps from your door.",
  "property_seo_title_contact": "Contact Us | Woodside Place Apartments",
  "property_seo_description_contact": "Reach out to Woodside Place Apartments in Gahanna, OH. Our leasing team is ready to assist you with one and two-bedroom floor plans. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Gahanna, OH",
  "property_seo_description_faqs": "Find answers to your questions at Woodside Place Apartments in Gahanna, OH. Explore community perks, floor plans, and more—all designed for your comfort!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Gahanna, OH",
  "property_seo_description_reviews": "Experience life at Woodside Place Apartments in Gahanna, OH! Check out resident reviews to see why our community is the perfect place to call home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Gahanna, OH",
  "property_seo_description_applynow": "Discover your ideal retreat at Woodside Place Apartments in Gahanna, OH. Spacious layouts, modern amenities, and a comfy community await. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Woodside Place Apartments",
  "property_seo_description_residentaccess": "Welcome to Woodside Place Apartments in Gahanna, OH! Access your resident portal for rent, maintenance, and community updates all in one spot!",
  "property_seo_title_referafriend": "Refer A Friend | Woodside Place Apartments",
  "property_seo_description_referafriend": "Refer a friend to Woodside Place Apartments in Gahanna, OH! Enjoy community living and exclusive rewards. Your perfect home awaits!",
  "property_seo_title_scheduletour": "Schedule a Tour | Woodside Place Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Woodside Place Apartments in Gahanna, OH. Schedule your tour today and envision your new home in a vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Woodside Place Apartments",
  "property_seo_description_privacy": "Your privacy matters at Woodside Place Apartments in Gahanna, OH. Learn how we safeguard your information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Woodside Place Apartments",
  "property_seo_description_accessibility": "At Woodside Place Apartments in Gahanna, OH, we prioritize digital inclusion. Learn how we make our community accessible for everyone. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Woodside Place Apartments",
  "property_seo_description_sitemap": "Uncover the beauty of Woodside Place Apartments in Gahanna, OH. Easily navigate our sitemap to find the perfect home and amenities tailored for you!",
  "property_seo_title_thankyou": "Thank You | Woodside Place Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Woodside Place Apartments in Gahanna, OH! A team member will be in touch soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Gahanna, OH",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1780679265650",
  "amenities": [
    {
      "id": "ec_3aea658e6e715e4bb1eadde3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "realpage",
      "external_id": "P000000206",
      "title": "Private Entrances",
      "amount": "0.0000",
      "description": "Private Entrances",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6938d367a27ea5b46d8db41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "realpage",
      "external_id": "P000000279",
      "title": "Detached and Attached Garages",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5f6bcf4f22c7bb8dc895378",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "realpage",
      "external_id": "P000000286",
      "title": "Convenient Location",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8fb81b4f588da083da21a091",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "realpage",
      "external_id": "P000000618",
      "title": "Flexible Rent Payments",
      "amount": "0.0000",
      "description": "Pay Rent Your Way With Flex",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f77ada89e72256c8a8bd9dd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "realpage",
      "external_id": "P000000289",
      "title": "Fully Equipped Kitchens",
      "amount": "0.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef7197e92599c0d4e82201e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "realpage",
      "external_id": "P000000665",
      "title": "Washer/Dryer Hookup",
      "amount": "0.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73f022e85b3069fb793d2d18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "realpage",
      "external_id": "P000000692",
      "title": "High Speed Internet",
      "amount": "0.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ea3bf21fa5fe794158a14aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "realpage",
      "external_id": "P000000693",
      "title": "Central Heat & Air",
      "amount": "0.0000",
      "description": "Central Heat & Air",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5673df99b2cdae252b6cf38a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "realpage",
      "external_id": "S100000264",
      "title": "Dishwasher",
      "amount": "0.0000",
      "description": "Dishwasher",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8c07bf89-cf92-457e-8a2a-775c87f73e91",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-7e96-76a3-8944-cd52e40ec9ce.webp",
      "image_media": {
        "alt_text": "Living room with a green sofa, blue armchair, and a high-top table with stools at Woodside Place Apartments in Columbus, OH.",
        "public_id": "019dc045-7e96-76a3-8944-cd52e40ec9ce",
        "storage_key": "property/6767906449167382/019dc045-7e96-76a3-8944-cd52e40ec9ce.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable living room, featuring a plush green sofa, a cozy blue armchair, and a stylish high-top table perfect for casual dining or socializing.",
      "link": "",
      "alt_text": "Living room with a green sofa, blue armchair, and a high-top table with stools at Woodside Place Apartments in Columbus, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_944366d9-270f-4dc8-af8c-3cd237ddeeea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-7cf0-70df-a680-f35e5a6ab9bb.webp",
      "image_media": {
        "alt_text": "Cozy living room with green sofa, blue armchair, coffee table, and decor at Woodside Place, offering apartments in Columbus, OH.",
        "public_id": "019dc045-7cf0-70df-a680-f35e5a6ab9bb",
        "storage_key": "property/6767906449167382/019dc045-7cf0-70df-a680-f35e5a6ab9bb.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Relax in this comfortable living space, featuring a plush green sofa, a stylish blue accent chair, and a wooden coffee table perfect for entertaining.",
      "link": "",
      "alt_text": "Cozy living room with green sofa, blue armchair, coffee table, and decor at Woodside Place, offering apartments in Columbus, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da35d6c4-dd3b-4973-bc81-2597563432db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-7c4c-772d-96a4-d07498a155ff.webp",
      "image_media": {
        "alt_text": "Bedroom with white comforter on bed and two closets at Woodside Place, offering apartments in Columbus, OH.",
        "public_id": "019dc045-7c4c-772d-96a4-d07498a155ff",
        "storage_key": "property/6767906449167382/019dc045-7c4c-772d-96a4-d07498a155ff.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a plush white comforter on the bed and two spacious closets for storage.",
      "link": "",
      "alt_text": "Bedroom with white comforter on bed and two closets at Woodside Place, offering apartments in Columbus, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d1dcd53-4a23-453f-b8f9-703407c6abb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-79b5-74c9-9fe2-ef831b93ffe2.webp",
      "image_media": {
        "alt_text": "Bedroom with houndstooth bedding, fish art, and a red beanbag chair at Woodside Place, offering townhomes in Columbus, OH.",
        "public_id": "019dc045-79b5-74c9-9fe2-ef831b93ffe2",
        "storage_key": "property/6767906449167382/019dc045-79b5-74c9-9fe2-ef831b93ffe2.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring unique fish-themed artwork, comfortable houndstooth bedding, and a playful red beanbag chair, creating a vibrant and personal space.",
      "link": "",
      "alt_text": "Bedroom with houndstooth bedding, fish art, and a red beanbag chair at Woodside Place, offering townhomes in Columbus, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aec06014-669c-44f5-b69c-75f44cbd00b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-7b1e-744e-b0f3-9e737158e2ac.webp",
      "image_media": {
        "alt_text": "Bathroom with white bathtub, toilet, sink, and mirrored cabinet at Woodside Place, offering townhomes for rent in Columbus, OH.",
        "public_id": "019dc045-7b1e-744e-b0f3-9e737158e2ac",
        "storage_key": "property/6767906449167382/019dc045-7b1e-744e-b0f3-9e737158e2ac.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "A clean and functional apartment bathroom featuring a white bathtub, toilet, sink, and a wooden-framed mirrored cabinet.",
      "link": "",
      "alt_text": "Bathroom with white bathtub, toilet, sink, and mirrored cabinet at Woodside Place, offering townhomes for rent in Columbus, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7ee22cdc-c3e6-4f89-910a-8409127ec345",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-78b8-72ea-b2ea-846883225622.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, window, and a bed at Woodside Place, offering townhomes in Columbus, OH.",
        "public_id": "019dc045-78b8-72ea-b2ea-846883225622",
        "storage_key": "property/6767906449167382/019dc045-78b8-72ea-b2ea-846883225622.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a white dresser with a lamp and books, a large window with dark curtains, and a bed with a houndstooth pattern comforter.",
      "link": "",
      "alt_text": "Bedroom with a dresser, window, and a bed at Woodside Place, offering townhomes in Columbus, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4d23e2ac-1bd4-4bad-b940-54edd29e7396",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-7769-7429-82d8-cd3e9884606a.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, nightstand, and dresser at Woodside Place, offering townhomes for rent in Columbus, OH.",
        "public_id": "019dc045-7769-7429-82d8-cd3e9884606a",
        "storage_key": "property/6767906449167382/019dc045-7769-7429-82d8-cd3e9884606a.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a queen-sized bed, elegant nightstand, and a spacious dresser for all your storage needs.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-sized bed, nightstand, and dresser at Woodside Place, offering townhomes for rent in Columbus, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d57a22d-aa54-42e0-8788-2a0d027de5b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-6b8f-725d-b6a6-5286dd37c9ee.webp",
      "image_media": {
        "alt_text": "Apartment building exteriors with manicured landscaping and a walkway at Woodside Place in Columbus, OH.",
        "public_id": "019dc045-6b8f-725d-b6a6-5286dd37c9ee",
        "storage_key": "property/6767906449167382/019dc045-6b8f-725d-b6a6-5286dd37c9ee.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Community",
      "description": "Charming apartment building exteriors featuring brick facades, neatly trimmed hedges, and inviting walkways. Experience comfortable living in a well-maintained community.",
      "link": "",
      "alt_text": "Apartment building exteriors with manicured landscaping and a walkway at Woodside Place in Columbus, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2fb4607b-e990-431c-8007-579edaf65319",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-6543-74da-882f-16a6a60b48c9.webp",
      "image_media": {
        "alt_text": "Woodside Place Apartments monument sign with address 3444",
        "public_id": "019dc045-6543-74da-882f-16a6a60b48c9",
        "storage_key": "property/6767906449167382/019dc045-6543-74da-882f-16a6a60b48c9.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Community",
      "description": "Welcome to Woodside Place Apartments, located at 3444. Discover comfortable living in a convenient location.",
      "link": "",
      "alt_text": "Woodside Place Apartments monument sign with address 3444",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d1d408e-2e5e-4544-85c2-f420cb2651e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-6b0c-72df-a45f-bbea0dfe1785.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, double sink, and white stove at Woodside Place, offering apartments near downtown Columbus, OH.",
        "public_id": "019dc045-6b0c-72df-a45f-bbea0dfe1785",
        "storage_key": "property/6767906449167382/019dc045-6b0c-72df-a45f-bbea0dfe1785.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring light wood cabinetry, a double basin sink, and a white electric range. Perfect for home-cooked meals.",
      "link": "",
      "alt_text": "Kitchen with light wood cabinets, double sink, and white stove at Woodside Place, offering apartments near downtown Columbus, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a0ee82f0-6dee-4db1-957b-5984b519e916",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-660b-7775-ae25-4b162d96e56b.webp",
      "image_media": {
        "alt_text": "Brick apartment buildings surrounded by lush green grass and blooming trees at Woodside Place, offering apartments near downtown Columbus, OH.",
        "public_id": "019dc045-660b-7775-ae25-4b162d96e56b",
        "storage_key": "property/6767906449167382/019dc045-660b-7775-ae25-4b162d96e56b.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Community",
      "description": "Experience charming apartment living with beautiful landscaping and mature trees. Enjoy the serene atmosphere of this community.",
      "link": "",
      "alt_text": "Brick apartment buildings surrounded by lush green grass and blooming trees at Woodside Place, offering apartments near downtown Columbus, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c31f9eb8-1739-439e-90fc-df4ad54537b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-6444-73e6-be1c-90aaa3972095.webp",
      "image_media": {
        "alt_text": "Brick apartment buildings with manicured lawns and blooming trees at Woodside Place, offering apartments near downtown Columbus, OH.",
        "public_id": "019dc045-6444-73e6-be1c-90aaa3972095",
        "storage_key": "property/6767906449167382/019dc045-6444-73e6-be1c-90aaa3972095.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Community",
      "description": "Charming brick apartment buildings surrounded by lush green lawns and beautiful flowering trees, offering a serene and welcoming community atmosphere.",
      "link": "",
      "alt_text": "Brick apartment buildings with manicured lawns and blooming trees at Woodside Place, offering apartments near downtown Columbus, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2a6c2f1f-d20c-4e64-b794-49c61ec2ac4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-652b-754d-b998-84e2c2008349.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, patterned armchair, coffee table, and dining area at Woodside Place, offering apartments in Gahanna, OH.",
        "public_id": "019dc045-652b-754d-b998-84e2c2008349",
        "storage_key": "property/6767906449167382/019dc045-652b-754d-b998-84e2c2008349.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable gray sofa, a decorative armchair, and a wooden coffee table. Adjacent dining area perfect for meals and work.",
      "link": "",
      "alt_text": "Living room with a gray sofa, patterned armchair, coffee table, and dining area at Woodside Place, offering apartments in Gahanna, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba6a8d4a-d733-4489-bcb0-1ee43eb33bed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-658d-7714-a5f7-a4285d56969f.webp",
      "image_media": {
        "alt_text": "Living room with stairs and a front door at Woodside Place, offering apartments in Gahanna, OH.",
        "public_id": "019dc045-658d-7714-a5f7-a4285d56969f",
        "storage_key": "property/6767906449167382/019dc045-658d-7714-a5f7-a4285d56969f.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Living area with a view of the stairs and the entrance to the apartment.",
      "link": "",
      "alt_text": "Living room with stairs and a front door at Woodside Place, offering apartments in Gahanna, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eb6da28d-a021-4737-a4df-e7f64472af5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-6576-7658-a8aa-303ce9f92859.webp",
      "image_media": {
        "alt_text": "Exterior view of a row of garage doors numbered 15, 17, and others, with a parking lot and cars to the right at Woodside Place, offering apartments in Gahanna, OH.",
        "public_id": "019dc045-6576-7658-a8aa-303ce9f92859",
        "storage_key": "property/6767906449167382/019dc045-6576-7658-a8aa-303ce9f92859.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Community",
      "description": "Secure your vehicle in our convenient garage parking. Ample parking available in our community.",
      "link": "",
      "alt_text": "Exterior view of a row of garage doors numbered 15, 17, and others, with a parking lot and cars to the right at Woodside Place, offering apartments in Gahanna, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3acd57b8-b201-41ef-9c84-f7f9ff2d49da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-65e4-77ce-a093-00c9fd47f9c5.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white refrigerator, dishwasher, microwave, and oven at Woodside Place, offering apartments in Gahanna, OH.",
        "public_id": "019dc045-65e4-77ce-a093-00c9fd47f9c5",
        "storage_key": "property/6767906449167382/019dc045-65e4-77ce-a093-00c9fd47f9c5.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this apartment kitchen featuring light wood cabinetry, a double sink, and essential appliances including a refrigerator, dishwasher, microwave, and oven.",
      "link": "",
      "alt_text": "Kitchen with light wood cabinets, white refrigerator, dishwasher, microwave, and oven at Woodside Place, offering apartments in Gahanna, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_12116550-e858-419e-a014-e992d89a0e0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-651a-7187-995c-de7f0dfa4e77.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, coffee table, and a desk area with chairs at Woodside Place, offering townhomes in Gahanna, OH.",
        "public_id": "019dc045-651a-7187-995c-de7f0dfa4e77",
        "storage_key": "property/6767906449167382/019dc045-651a-7187-995c-de7f0dfa4e77.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable gray sofa, a rustic coffee table, and a dedicated workspace. Perfect for relaxation and productivity.",
      "link": "",
      "alt_text": "Living room with a gray sofa, coffee table, and a desk area with chairs at Woodside Place, offering townhomes in Gahanna, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d396f3ce-64c0-45e6-a942-2d5b24520d2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor at Woodside Place, offering townhomes in Gahanna, OH.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "title": "Apartment",
      "description": "Cozy living room with ample seating, perfect for relaxation or entertaining guests. Features include a stylish grey sofa, a rustic coffee table, and convenient stairs for easy access to the upper level.",
      "link": "",
      "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor at Woodside Place, offering townhomes in Gahanna, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d0a42e66-63a4-4abe-9304-60e124b3524b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "3975 Townsfair Way, Columbus, OH 43219, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious appetizers, burgers, pasta, and cheesecake. They also highlight the large portions, satisfying food, and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb53-b7f0-74ba-a12b-fcf0717b5ca4.webp",
      "poi_featured_image_media": {
        "alt_text": "The Cheesecake Factory restaurant exterior with signage.",
        "public_id": "019dbb53-b7f0-74ba-a12b-fcf0717b5ca4",
        "storage_key": "property/6767906449167382/019dbb53-b7f0-74ba-a12b-fcf0717b5ca4.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/oh/columbus-30.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=7719816661101130461&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "40.0486779",
      "poi_longitude": "-82.91565609999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-418-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ec98-7569-ad29-90c796284c52.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019dbb5c-ec98-7569-ad29-90c796284c52",
        "storage_key": "property/6767906449167382/019dbb5c-ec98-7569-ad29-90c796284c52.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPW2s_XyKOIgR3TITGFpMIms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7d2bd8d7-a8aa-4704-b454-c51251fe5a9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Brazilian Grill & Bakery",
      "poi_type": "Restaurants",
      "poi_address": "5818 Columbus Square, Columbus, OH 43231, USA",
      "poi_short_description": "Casual, Brazilian eatery offering a buffet and a grocery store with imported goods.",
      "poi_long_description": "People say this Brazilian restaurant offers a delicious buffet with a variety of meats, including picanha, and a selection of sides, as well as fresh juices and desserts. They highlight the affordable prices, authentic Brazilian atmosphere, and the attached grocery store with a wide selection of Brazilian products. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc02b-4a47-72d6-a127-13a1e3bca54f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dc02b-4a47-72d6-a127-13a1e3bca54f",
        "storage_key": "property/6767906449167382/019dc02b-4a47-72d6-a127-13a1e3bca54f.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://www.braziliangrillandbakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5948046587466194481&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brazilian-grill--bakery",
      "poi_latitude": "40.0886684",
      "poi_longitude": "-82.9489432",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 614-394-9254",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ec98-7569-ad29-90c796284c52.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019dbb5c-ec98-7569-ad29-90c796284c52",
        "storage_key": "property/6767906449167382/019dbb5c-ec98-7569-ad29-90c796284c52.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5WCDEtaKOIgRMZ5lcdu0i1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "custom_a8c79e2e-423f-4890-bdd7-86b3f7684a7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Texas de Brazil - Columbus",
      "poi_type": "Restaurants",
      "poi_address": "4040 Easton Station Suite E 105, Columbus, OH 43219, USA",
      "poi_short_description": "Upscale Brazilian eatery featuring all-you-can-eat grilled meat carved tableside & a salad bar.",
      "poi_long_description": "People say this steakhouse offers a wide variety of delicious meats, including beef, pork, chicken, and Brazilian sausage, as well as a salad bar and sides. They also highlight the friendly and courteous service, and the fun and lively atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb54-0d02-724a-a884-2eb8c4001c0a.webp",
      "poi_featured_image_media": {
        "alt_text": "Elegant dining room with tables set for dinner.",
        "public_id": "019dbb54-0d02-724a-a884-2eb8c4001c0a",
        "storage_key": "property/6767906449167382/019dbb54-0d02-724a-a884-2eb8c4001c0a.webp",
        "width": 3072,
        "height": 2060
      },
      "poi_business_url": "https://texasdebrazil.com/locations/columbus/?utm_source=gmb&utm_medium=yext&y_source=1_NDg4MzA3MzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4090752085257190938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-de-brazil---columbus",
      "poi_latitude": "40.0500034",
      "poi_longitude": "-82.9134371",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-470-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ec98-7569-ad29-90c796284c52.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019dbb5c-ec98-7569-ad29-90c796284c52",
        "storage_key": "property/6767906449167382/019dbb5c-ec98-7569-ad29-90c796284c52.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZy3KEX2KOIgRGn7xCVlFxTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_7be3f49f-a288-49e2-bb07-474d1086bca6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Cooper’s Hawk Winery & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4230 The Strand, Columbus, OH 43219, USA",
      "poi_short_description": "Upscale chain serving New American fare paired with house-label  wines in a contemporary setting.",
      "poi_long_description": "People say this restaurant serves delicious drunken shrimp, pretzel bread, and short ribs. They also highlight the attentive service, knowledgeable staff, and fun wine tasting experience.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb53-b778-71a2-bd6a-a4e377282b93.webp",
      "poi_featured_image_media": {
        "alt_text": "Cooper's Hawk restaurant exterior with signage.",
        "public_id": "019dbb53-b778-71a2-bd6a-a4e377282b93",
        "storage_key": "property/6767906449167382/019dbb53-b778-71a2-bd6a-a4e377282b93.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "https://chwinery.com/locations/ohio/columbus",
      "poi_directions_map_url": "https://maps.google.com/?cid=5350335836918925867&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "coopers-hawk-winery--restaurant",
      "poi_latitude": "40.0541722",
      "poi_longitude": "-82.9149389",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-428-6999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ec98-7569-ad29-90c796284c52.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019dbb5c-ec98-7569-ad29-90c796284c52",
        "storage_key": "property/6767906449167382/019dbb5c-ec98-7569-ad29-90c796284c52.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLUYj_4aKOIgRK0qYrBg2QEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_41f19175-97df-49de-b63b-72d994f6c22f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Another Broken Egg Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3942 Townsfair Way, Columbus, OH 43219, USA",
      "poi_short_description": "Casual chain featuring egg dishes & other breakfast items, plus brunch sandwiches.",
      "poi_long_description": "People say this brunch restaurant serves delicious cinnamon roll French toast, shrimp and grits, and omelettes. They highlight the generous portions, reasonable prices, and lively atmosphere. They also like the friendly, attentive, and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb55-1b0f-70c5-9a2b-2da3ecd5b535.webp",
      "poi_featured_image_media": {
        "alt_text": "Dining area with tables and chairs",
        "public_id": "019dbb55-1b0f-70c5-9a2b-2da3ecd5b535",
        "storage_key": "property/6767906449167382/019dbb55-1b0f-70c5-9a2b-2da3ecd5b535.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.anotherbrokenegg.com/locations/columbus-oh/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10348537269079115454&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "another-broken-egg-cafe",
      "poi_latitude": "40.049264",
      "poi_longitude": "-82.9167768",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-532-6782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ec98-7569-ad29-90c796284c52.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019dbb5c-ec98-7569-ad29-90c796284c52",
        "storage_key": "property/6767906449167382/019dbb5c-ec98-7569-ad29-90c796284c52.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxVx3CQiLOIgRvgZaPNFjnY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_b5285108-9c8f-4be8-926d-151c2fff9d7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Easton Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "160 Easton Town Ctr, Columbus, OH 43219, USA",
      "poi_short_description": "Sprawling venue with lots of shops & restaurants, plus a theater, outdoor concerts & holiday events.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including high-end brands and popular retail chains, as well as a movie theater and entertainment options. They highlight the beautiful design, comfortable walking areas, and the clean, well-organized atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc02b-43ab-744a-828e-d15f6732004e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dc02b-43ab-744a-828e-d15f6732004e",
        "storage_key": "property/6767906449167382/019dc02b-43ab-744a-828e-d15f6732004e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://eastontowncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7959530323082981520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "easton-town-center",
      "poi_latitude": "40.0505153",
      "poi_longitude": "-82.915308",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-337-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ece3-706b-a055-21b7d277649d.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dbb5c-ece3-706b-a055-21b7d277649d",
        "storage_key": "property/6767906449167382/019dbb5c-ece3-706b-a055-21b7d277649d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG9vehYeKOIgRkLBPTqjudW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8bc7f1e8-fb94-454c-a08d-8abf2fac30ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Saraga International Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "1265 Morse Rd, Columbus, OH 43229, USA",
      "poi_short_description": "Grocery store selling fresh produce and meats, along with prepared foods and baked goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of international products, including fresh produce, seafood, and pantry items from countries like Mexico, Asia, and Europe. They also highlight the reasonable prices, diverse selection, and clean environment.\n\nSome reviews mention the meat can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb53-acf8-756e-84a2-b25e703badb7.webp",
      "poi_featured_image_media": {
        "alt_text": "Saraga International Grocery store exterior with signage and entrance.",
        "public_id": "019dbb53-acf8-756e-84a2-b25e703badb7",
        "storage_key": "property/6767906449167382/019dbb53-acf8-756e-84a2-b25e703badb7.webp",
        "width": 2048,
        "height": 1536
      },
      "poi_business_url": "http://saragaohio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15469160277800290888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saraga-international-grocery",
      "poi_latitude": "40.0599556",
      "poi_longitude": "-82.98528329999999",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 614-447-8588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecef-70eb-8e31-d8de727df4ea.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dbb5c-ecef-70eb-8e31-d8de727df4ea",
        "storage_key": "property/6767906449167382/019dbb5c-ecef-70eb-8e31-d8de727df4ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJccf2c3mLOIgRSIreQ1B_rdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_755a3a79-fda2-4dbe-a8f1-6fc1ebb2f093",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "3888 Townsfair Way, Columbus, OH 43219, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and delicious items, including fresh produce, frozen foods, and specialty snacks. They highlight the affordable prices and the fun, engaging shopping experience. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb53-b856-70fb-9d1d-22c4dc22716b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbb53-b856-70fb-9d1d-22c4dc22716b",
        "storage_key": "property/6767906449167382/019dbb53-b856-70fb-9d1d-22c4dc22716b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/oh/columbus/679/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11117395075831252904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "40.0493003",
      "poi_longitude": "-82.9180099",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-473-0794",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecef-70eb-8e31-d8de727df4ea.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dbb5c-ecef-70eb-8e31-d8de727df4ea",
        "storage_key": "property/6767906449167382/019dbb5c-ecef-70eb-8e31-d8de727df4ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWwD71XyKOIgRqEeZQuvrSJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_90bedccb-2386-4432-8345-c8c0d6df4a91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4100 Easton Gateway Dr, Columbus, OH 43219, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, high-quality produce, specialty items, and prepared foods. They also highlight the friendly and helpful staff, and the clean, well-organized, and pleasant shopping environment.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb53-b912-744b-90ce-a6435786c161.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbb53-b912-744b-90ce-a6435786c161",
        "storage_key": "property/6767906449167382/019dbb53-b912-744b-90ce-a6435786c161.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/easton?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=18386441578182638374&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "40.0570337",
      "poi_longitude": "-82.90956109999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-536-0570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecef-70eb-8e31-d8de727df4ea.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dbb5c-ecef-70eb-8e31-d8de727df4ea",
        "storage_key": "property/6767906449167382/019dbb5c-ecef-70eb-8e31-d8de727df4ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWgiIipgOIgRJnsMJzPDKf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_edcbd75c-01f5-4e3e-b3c3-980cf12b4331",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2345 Silver Dr, Columbus, OH 43211, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of products and has a great layout. They also highlight the helpful and knowledgeable staff, and the convenient self-checkout.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb53-ab2e-7018-b5e8-741998f75a92.webp",
      "poi_featured_image_media": {
        "alt_text": "Lowe's company logo on the exterior of a building.",
        "public_id": "019dbb53-ab2e-7018-b5e8-741998f75a92",
        "storage_key": "property/6767906449167382/019dbb53-ab2e-7018-b5e8-741998f75a92.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OH-Columbus/1175?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1175-_-na-_-0-_-0&y_source=1_MTE4MzY5OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1504361396977286858&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "40.013526",
      "poi_longitude": "-82.9946",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 614-447-2851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ece3-706b-a055-21b7d277649d.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dbb5c-ece3-706b-a055-21b7d277649d",
        "storage_key": "property/6767906449167382/019dbb5c-ece3-706b-a055-21b7d277649d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgffaQquOOIgRyj6kWLiQ4BQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_be2065b4-dd08-44de-8113-2366a9c2c82b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Otterbein University",
      "poi_type": "Education",
      "poi_address": "1 S Grove St, Westerville, OH 43081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb53-f2f2-759d-884e-9986ba51bb71.webp",
      "poi_featured_image_media": {
        "alt_text": "Historic brick building on the Otterbein University campus with a lawn and trees.",
        "public_id": "019dbb53-f2f2-759d-884e-9986ba51bb71",
        "storage_key": "property/6767906449167382/019dbb53-f2f2-759d-884e-9986ba51bb71.webp",
        "width": 2048,
        "height": 1365
      },
      "poi_business_url": "https://www.otterbein.edu/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=12768663309059927298&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "otterbein-university",
      "poi_latitude": "40.1268746",
      "poi_longitude": "-82.9371852",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 614-890-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-eca6-7239-8a1a-ac1b9aca17e5.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dbb5c-eca6-7239-8a1a-ac1b9aca17e5",
        "storage_key": "property/6767906449167382/019dbb5c-eca6-7239-8a1a-ac1b9aca17e5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMVjn7Q_1OIgRAq0U2aBnM7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1950b269-f385-4420-9bef-099830490efe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Ohio Dominican University",
      "poi_type": "Education",
      "poi_address": "1216 Sunbury Rd, Columbus, OH 43219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb9e-27c3-72a3-b658-c413302857d5.webp",
      "poi_featured_image_media": {
        "alt_text": "Historic brick building with a steeple and a manicured lawn.",
        "public_id": "019dbb9e-27c3-72a3-b658-c413302857d5",
        "storage_key": "property/6767906449167382/019dbb9e-27c3-72a3-b658-c413302857d5.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.ohiodominican.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9368482804598465447&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ohio-dominican-university",
      "poi_latitude": "39.9940322",
      "poi_longitude": "-82.939882",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 614-251-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-eca6-7239-8a1a-ac1b9aca17e5.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dbb5c-eca6-7239-8a1a-ac1b9aca17e5",
        "storage_key": "property/6767906449167382/019dbb5c-eca6-7239-8a1a-ac1b9aca17e5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnSfZT5iJOIgRp2NydHmJA4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_60eac8af-58a3-4737-be96-4edda641c071",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Westerville Public Library",
      "poi_type": "Education",
      "poi_address": "126 S State St, Westerville, OH 43081, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this public library offers a wide variety of resources, including books, DVDs, audiobooks, periodicals, and online language learning, as well as access to a Cricut machine, 3D printing services, and a museum. They highlight the library's spacious layout, numerous activities for children and adults, and the used book sales. They also like the helpful and kind staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb53-f01b-72fb-a1a8-2fd7a2d43de3.webp",
      "poi_featured_image_media": {
        "alt_text": "A young boy building a tower with colorful blocks.",
        "public_id": "019dbb53-f01b-72fb-a1a8-2fd7a2d43de3",
        "storage_key": "property/6767906449167382/019dbb53-f01b-72fb-a1a8-2fd7a2d43de3.webp",
        "width": 1058,
        "height": 692
      },
      "poi_business_url": "https://www.westervillelibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7529948867192542482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westerville-public-library",
      "poi_latitude": "40.1230063",
      "poi_longitude": "-82.9300492",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 614-882-7277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-eca6-7239-8a1a-ac1b9aca17e5.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dbb5c-eca6-7239-8a1a-ac1b9aca17e5",
        "storage_key": "property/6767906449167382/019dbb5c-eca6-7239-8a1a-ac1b9aca17e5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt9VlvhL1OIgREtXdbZnAf2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_4b90662c-447f-48b1-846a-5159c7e2eca9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Columbus Metropolitan Library: Gahanna Branch",
      "poi_type": "Education",
      "poi_address": "310 Granville St, Gahanna, OH 43230, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb53-f22a-7214-8132-22674cc78ab6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbb53-f22a-7214-8132-22674cc78ab6",
        "storage_key": "property/6767906449167382/019dbb53-f22a-7214-8132-22674cc78ab6.webp",
        "width": 1800,
        "height": 1200
      },
      "poi_business_url": "http://www.columbuslibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10296873782435341254&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "columbus-metropolitan-library-gahanna-branch",
      "poi_latitude": "40.019006",
      "poi_longitude": "-82.86982669999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 614-645-2275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-eca6-7239-8a1a-ac1b9aca17e5.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dbb5c-eca6-7239-8a1a-ac1b9aca17e5",
        "storage_key": "property/6767906449167382/019dbb5c-eca6-7239-8a1a-ac1b9aca17e5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu1N0ZpthOIgRxmMXYybY5Y4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_f988aa0e-f0fb-401b-9de3-de078b58596e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Historic Crew Stadium",
      "poi_type": "Entertainment",
      "poi_address": "One Black and Gold Blvd, Columbus, OH 43211, USA",
      "poi_short_description": "22,555-seat, major league soccer venue hosting additional sporting events & outdoor concerts.",
      "poi_long_description": "People say this stadium is a great place to see concerts and events, especially the Sonic Temple festival. They highlight the clean bathrooms, comfortable seating, and excellent sound quality. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb9e-a7e1-720c-9204-3e5e94f5e906.webp",
      "poi_featured_image_media": {
        "alt_text": "Soccer game at MAPFRE Stadium during a colorful sunset.",
        "public_id": "019dbb9e-a7e1-720c-9204-3e5e94f5e906",
        "storage_key": "property/6767906449167382/019dbb9e-a7e1-720c-9204-3e5e94f5e906.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.historiccrewstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3124569632918207391&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "historic-crew-stadium",
      "poi_latitude": "40.0095288",
      "poi_longitude": "-82.99116219999999",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 614-447-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc02b-59f3-7092-8cb4-01ca24269d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dc02b-59f3-7092-8cb4-01ca24269d0f",
        "storage_key": "property/6767906449167382/019dc02b-59f3-7092-8cb4-01ca24269d0f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk4BJbVOJOIgRn_sPxoazXCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_d58574fb-caf3-4bb7-9d92-678b0f43830a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Ohio History Center",
      "poi_type": "Entertainment",
      "poi_address": "800 E 17th Ave, Columbus, OH 43211, USA",
      "poi_short_description": "Exhibits cover the state's history plus Ohio Village, an interactive re-creation of an 1860s town.",
      "poi_long_description": "People say this history museum offers a wide variety of exhibits showcasing Ohio's history, including hands-on sections and a full Mastodon fossil. They highlight the museum is clean, family-friendly, and usually not crowded, making it a great spot to learn and reflect. They also like the informative and engaging \"Night at the Museum\" events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc02b-4a52-7688-b120-ba94aca77f08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dc02b-4a52-7688-b120-ba94aca77f08",
        "storage_key": "property/6767906449167382/019dc02b-4a52-7688-b120-ba94aca77f08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ohiohistory.org/visit/ohio-history-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12677374854580083323&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ohio-history-center",
      "poi_latitude": "40.0048317",
      "poi_longitude": "-82.9873667",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-297-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc02b-59fd-768a-89ba-46924a43490f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dc02b-59fd-768a-89ba-46924a43490f",
        "storage_key": "property/6767906449167382/019dc02b-59fd-768a-89ba-46924a43490f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJEZXghFGJOIgRexq3O0MV768",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_34159236-d1af-4693-8453-c895d6197817",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Taft Coliseum",
      "poi_type": "Entertainment",
      "poi_address": "716 E 17th Ave, Columbus, OH 43211, USA",
      "poi_short_description": "Long-running (since 1918) arena at the state fairgrounds hosting basketball games & other events.",
      "poi_long_description": "Long-running (since 1918) arena at the state fairgrounds hosting basketball games & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb54-3f52-77d2-b67c-6b20d79c1502.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of an ice hockey arena with red and blue seating around the rink.",
        "public_id": "019dbb54-3f52-77d2-b67c-6b20d79c1502",
        "storage_key": "property/6767906449167382/019dbb54-3f52-77d2-b67c-6b20d79c1502.webp",
        "width": 960,
        "height": 723
      },
      "poi_business_url": "http://www.ohioexpocenter.com/index.php/rental-facilities/buildings-and-floorplans/coliseum",
      "poi_directions_map_url": "https://maps.google.com/?cid=7991792038231173766&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "taft-coliseum",
      "poi_latitude": "39.9984323",
      "poi_longitude": "-82.9923441",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-466-8346",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc02b-59f3-7092-8cb4-01ca24269d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dc02b-59f3-7092-8cb4-01ca24269d0f",
        "storage_key": "property/6767906449167382/019dc02b-59f3-7092-8cb4-01ca24269d0f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmRY5OkuJOIgRhmqQNYSM6G4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_46661afe-080f-496b-ab83-d6757d79ca98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Ohio Village",
      "poi_type": "Entertainment",
      "poi_address": "800 E 17th Ave, Columbus, OH 43211, USA",
      "poi_short_description": "Themed village featuring 19th-century buildings and costumed actors.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc02b-4c2e-721b-a344-e3a369a7e1ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dc02b-4c2e-721b-a344-e3a369a7e1ea",
        "storage_key": "property/6767906449167382/019dc02b-4c2e-721b-a344-e3a369a7e1ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ohiohistory.org/visit/ohio-village",
      "poi_directions_map_url": "https://maps.google.com/?cid=793164285504011893&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ohio-village",
      "poi_latitude": "40.006516",
      "poi_longitude": "-82.9868793",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-686-6124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc02b-59fd-768a-89ba-46924a43490f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dc02b-59fd-768a-89ba-46924a43490f",
        "storage_key": "property/6767906449167382/019dc02b-59fd-768a-89ba-46924a43490f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJryIZAk6JOIgRdT7-HbfiAQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6b402037-fcf3-4555-a3b5-2881daa68040",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Bexley High School Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Bexley, OH 43209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb54-409f-727f-b582-caf500044e8c.webp",
      "poi_featured_image_media": {
        "alt_text": "A young person wearing glasses and a tie stands on a sidewalk outside a brick building.",
        "public_id": "019dbb54-409f-727f-b582-caf500044e8c",
        "storage_key": "property/6767906449167382/019dbb54-409f-727f-b582-caf500044e8c.webp",
        "width": 585,
        "height": 585
      },
      "poi_business_url": "http://ohiostadiums.com/stadium.php?id=2044",
      "poi_directions_map_url": "https://maps.google.com/?cid=11138267811669287094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bexley-high-school-stadium",
      "poi_latitude": "39.9633348",
      "poi_longitude": "-82.9289622",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc02b-59f3-7092-8cb4-01ca24269d0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dc02b-59f3-7092-8cb4-01ca24269d0f",
        "storage_key": "property/6767906449167382/019dc02b-59f3-7092-8cb4-01ca24269d0f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8RFY90KJOIgRtiC3x48Tk5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_690792d1-0400-42bc-8d01-986f87f1a8b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Gahanna/John E. Bickley YMCA - YMCA of Central Ohio",
      "poi_type": "Health and Wellness",
      "poi_address": "555 YMCA Pl, Gahanna, OH 43230, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "People say this gym offers a variety of equipment, including newer machines, old-school pieces, and dumbbells up to 125 lbs. They also highlight the friendly and helpful staff, and the clean and well-maintained facility.\n\nOther reviews mention the weight training area can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb54-a43b-7744-8b74-3c5663b9256f.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the YMCA building with a playground on the left and the YMCA logo above the entrance.",
        "public_id": "019dbb54-a43b-7744-8b74-3c5663b9256f",
        "storage_key": "property/6767906449167382/019dbb54-a43b-7744-8b74-3c5663b9256f.webp",
        "width": 2500,
        "height": 1667
      },
      "poi_business_url": "https://ymcacolumbus.org/locations/gahanna?utm_source=google_business_profile&utm_medium=Organic&utm_campaign=gbp_gahanna",
      "poi_directions_map_url": "https://maps.google.com/?cid=6223918477235120507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gahannajohn-e-bickley-ymca---ymca-of-central-ohio",
      "poi_latitude": "40.0484216",
      "poi_longitude": "-82.85855880000001",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 614-389-4529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJixJldQJhOIgRe-mWGuHMX1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_60ecc574-f30f-4a11-9dae-d4ef74c5bc1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "340 S Hamilton Rd, Gahanna, OH 43230, USA",
      "poi_short_description": "Chain gym offering equipment, tanning beds, and hydro massages in a clean environment.",
      "poi_long_description": "People say this gym offers a wide variety of new equipment and machines, and the space is clean and spacious. They also highlight the friendly service and the recent updates to the facility.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb54-925c-755e-8933-bdc82708cbf8.webp",
      "poi_featured_image_media": {
        "alt_text": "People working out on various machines in a brightly lit gym.",
        "public_id": "019dbb54-925c-755e-8933-bdc82708cbf8",
        "storage_key": "property/6767906449167382/019dbb54-925c-755e-8933-bdc82708cbf8.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/gahanna-oh?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9135864402865720269&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.0113515",
      "poi_longitude": "-82.86486289999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 614-471-1177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-6KQ-4BhOIgRzYvyQEUcyX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b0d79117-5914-44fc-b83c-e1bc96eef9cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "3900 Easton Station, Columbus, OH 43219, USA",
      "poi_short_description": "Bright, clean, full-service gym with a childcare center for kids to play while parents work out.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and amenities, including pickleball courts, a pool, and a sauna. They also highlight the clean facilities, welcoming atmosphere, and helpful staff.\n\nOther reviews mention the membership dues can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb54-ca9e-713e-9f55-86005fa6af76.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a red brick building with large windows and a red awning.",
        "public_id": "019dbb54-ca9e-713e-9f55-86005fa6af76",
        "storage_key": "property/6767906449167382/019dbb54-ca9e-713e-9f55-86005fa6af76.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/oh/easton.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=8487008787250728014&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "40.0499783",
      "poi_longitude": "-82.91707819999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-428-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRyQPFn2KOIgRTsyyoYbpx3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_675bb5b6-d48c-4449-8ccf-513a5eff3d55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "North YMCA - YMCA of Central Ohio",
      "poi_type": "Health and Wellness",
      "poi_address": "1640 Sandalwood Pl, Columbus, OH 43229, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "People say this gym offers a variety of workout equipment, fitness classes, and amenities such as an indoor basketball court and pool. They also highlight the friendly and helpful staff, and the great sense of community.\n\nSome reviews mention the facilities can be run-down.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb55-02bb-75de-bbab-8dbc28fd2732.webp",
      "poi_featured_image_media": {
        "alt_text": "YMCA building exterior with American flag and trees.",
        "public_id": "019dbb55-02bb-75de-bbab-8dbc28fd2732",
        "storage_key": "property/6767906449167382/019dbb55-02bb-75de-bbab-8dbc28fd2732.webp",
        "width": 2048,
        "height": 1365
      },
      "poi_business_url": "https://ymcacolumbus.org/locations/north?utm_source=google_business_profile&utm_medium=Organic&utm_campaign=gbp_north",
      "poi_directions_map_url": "https://maps.google.com/?cid=15118320695958196620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-ymca---ymca-of-central-ohio",
      "poi_latitude": "40.0775233",
      "poi_longitude": "-82.9735905",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 614-389-4707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyxY9V0CLOIgRjFEGm5IQz9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6f5d58db-4847-4217-afe7-d168a7bf7afc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5959 Old Hamilton Rd, Westerville, OH 43081, USA",
      "poi_short_description": "Large, bustling fitness chain featuring an indoor track, pools, cardio equipment, free weights and sauna plus classes.",
      "poi_long_description": "Some gym goers say this gym has friendly staff and is mostly clean.\n\nOther reviews mention the equipment can be broken and maintenance can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb55-cb84-733d-9d45-1ba6abc67ede.webp",
      "poi_featured_image_media": {
        "alt_text": "Spacious, multi-level gym with various weight machines and free weights.",
        "public_id": "019dbb55-cb84-733d-9d45-1ba6abc67ede",
        "storage_key": "property/6767906449167382/019dbb55-cb84-733d-9d45-1ba6abc67ede.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1004&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=550487863757194050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "40.0778545",
      "poi_longitude": "-82.863221",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 614-476-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNUgBa4hgOIgRQkNppMu5owc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5c1377a5-34d1-48f5-8fc2-ff1485c9a157",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Eldon & Elsie Ward Family YMCA - YMCA of Central Ohio",
      "poi_type": "Health and Wellness",
      "poi_address": "130 Woodland Ave, Columbus, OH 43203, USA",
      "poi_short_description": "Gym, non-profit and community center featuring weightlifting fitness classes and other programs.",
      "poi_long_description": "People say this gym offers a variety of exercise classes, including yoga and swimming, and has a clean, welcoming, and friendly atmosphere. They also highlight the excellent customer service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb56-763d-76cf-a66b-63891cd9f4b8.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of the YMCA building with a sign and trees.",
        "public_id": "019dbb56-763d-76cf-a66b-63891cd9f4b8",
        "storage_key": "property/6767906449167382/019dbb56-763d-76cf-a66b-63891cd9f4b8.webp",
        "width": 2500,
        "height": 1667
      },
      "poi_business_url": "https://ymcacolumbus.org/locations/ward?utm_source=google_business_profile&utm_medium=Organic&utm_campaign=gbp_ward",
      "poi_directions_map_url": "https://maps.google.com/?cid=16194326930071933688&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eldon--elsie-ward-family-ymca---ymca-of-central-ohio",
      "poi_latitude": "39.9700881",
      "poi_longitude": "-82.95695979999999",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 614-389-4643",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLUX4tP2IOIgR-NJ6q4rOveA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2cb74b31-e6fe-42fe-931e-c6ee62a07706",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Mount Carmel East",
      "poi_type": "Health and Wellness",
      "poi_address": "6001 E Broad St, Columbus, OH 43213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb55-42f3-7664-8989-4cba5e4d31e5.webp",
      "poi_featured_image_media": {
        "alt_text": "Mount Carmel East hospital building exterior with signage and American flag.",
        "public_id": "019dbb55-42f3-7664-8989-4cba5e4d31e5",
        "storage_key": "property/6767906449167382/019dbb55-42f3-7664-8989-4cba5e4d31e5.webp",
        "width": 1778,
        "height": 1000
      },
      "poi_business_url": "https://www.mountcarmelhealth.com/location/mount-carmel-east",
      "poi_directions_map_url": "https://maps.google.com/?cid=8097889661284888292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mount-carmel-east",
      "poi_latitude": "39.9771598",
      "poi_longitude": "-82.84446419999999",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 614-234-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5d-0b82-771b-b41c-070d2aac5e3f.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019dbb5d-0b82-771b-b41c-070d2aac5e3f",
        "storage_key": "property/6767906449167382/019dbb5d-0b82-771b-b41c-070d2aac5e3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95Xp2ZdjOIgR5K4xE757YXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_2941e317-c033-4488-8a7f-9b7190e67dea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Ohio State East Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "181 Taylor Ave, Columbus, OH 43203, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb55-42eb-758f-9eaf-009d647d2f1e.webp",
      "poi_featured_image_media": {
        "alt_text": "The Ohio State University Hospital building exterior with the logo on top.",
        "public_id": "019dbb55-42eb-758f-9eaf-009d647d2f1e",
        "storage_key": "property/6767906449167382/019dbb55-42eb-758f-9eaf-009d647d2f1e.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://wexnermedical.osu.edu/locations/east-hospital?utm_campaign=med_general-awareness-evergreen_corp&utm_source=googlemybusiness&utm_medium=organic&utm_content=gmb_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4029450398547506445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ohio-state-east-hospital",
      "poi_latitude": "39.9706036",
      "poi_longitude": "-82.9622538",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 614-257-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5d-0b82-771b-b41c-070d2aac5e3f.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019dbb5d-0b82-771b-b41c-070d2aac5e3f",
        "storage_key": "property/6767906449167382/019dbb5d-0b82-771b-b41c-070d2aac5e3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTbvEsuSIOIgRDfV63cl76zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_f6e0a1a6-2689-4026-a736-b1060996f789",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Franklin Park Conservatory and Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1777 E Broad St, Columbus, OH 43203, USA",
      "poi_short_description": "88 acres of indoor/outdoor art- & nature-based exhibits, greenhouses & landscaped grounds.",
      "poi_long_description": "People say this botanical garden offers a stunning variety of plants, including bonsai trees, and features a beautiful butterfly exhibit. They highlight the peaceful and relaxing atmosphere, perfect for a leisurely stroll or picnic, and the well-maintained grounds with water features and a children's garden. They also like the friendly and helpful staff, and the unique glass sculptures and train display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb55-5c38-700d-b135-589c45459a8b.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a large greenhouse with manicured gardens and blooming flowers in front.",
        "public_id": "019dbb55-5c38-700d-b135-589c45459a8b",
        "storage_key": "property/6767906449167382/019dbb55-5c38-700d-b135-589c45459a8b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://fpconservatory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8151134564748058593&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "franklin-park-conservatory-and-botanical-gardens",
      "poi_latitude": "39.96587160000001",
      "poi_longitude": "-82.9532009",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-715-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB9mFbvmIOIgR4V83OLOlHnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_1c64f3d8-bfcc-40b1-a1b0-25454c3e3ca8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Inniswood Metro Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "940 S Hempstead Rd, Westerville, OH 43081, USA",
      "poi_short_description": "Nature preserve featuring formal gardens & lawns, a trail, with a center for workshops & a library.",
      "poi_long_description": "People say this park offers beautiful gardens, flowers, and landscaping, as well as walking paths, trails, and a tree house. They highlight the peaceful and serene atmosphere, and the opportunities for nature walks, bird watching, and meditation. They also like the well-maintained grounds and the variety of landscapes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb55-5a24-76c6-b065-bd38d5a1722c.webp",
      "poi_featured_image_media": {
        "alt_text": "Manicured garden with flowering tree and brick pathway",
        "public_id": "019dbb55-5a24-76c6-b065-bd38d5a1722c",
        "storage_key": "property/6767906449167382/019dbb55-5a24-76c6-b065-bd38d5a1722c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.inniswood.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9089113309968798275&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "inniswood-metro-gardens",
      "poi_latitude": "40.1008046",
      "poi_longitude": "-82.89912679999999",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 614-895-6216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5d-0b1a-756f-8b57-f95919d7c3d0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree",
        "public_id": "019dbb5d-0b1a-756f-8b57-f95919d7c3d0",
        "storage_key": "property/6767906449167382/019dbb5d-0b1a-756f-8b57-f95919d7c3d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13L2hfpfOIgRQxL3M2YEI34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3a76e6ad-c2d2-489e-afc1-f326761bc5ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Sharon Woods",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6911 Cleveland Ave, Westerville, OH 43081, USA",
      "poi_short_description": "Lake, jogging trails, nature walks & playground featured in 761-acre preserve with forests & fields.",
      "poi_long_description": "People say this city park offers a variety of trails for walking, biking, and hiking, as well as fishing ponds, playgrounds, and picnic areas. They highlight the beautiful scenery, including woods, a lake, and a gorge, and the well-maintained trails suitable for all ages and abilities. They also like the spaciousness of the park, with plenty of room for activities and relaxation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb55-8173-730d-ae2b-8940f35cf3c5.webp",
      "poi_featured_image_media": {
        "alt_text": "Autumn foliage surrounds picnic areas and parking lot.",
        "public_id": "019dbb55-8173-730d-ae2b-8940f35cf3c5",
        "storage_key": "property/6767906449167382/019dbb55-8173-730d-ae2b-8940f35cf3c5.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.metroparks.net/parks-and-trails/sharon-woods/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12816708023515657661&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sharon-woods",
      "poi_latitude": "40.1165707",
      "poi_longitude": "-82.96222949999999",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 614-315-5520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5d-0b1a-756f-8b57-f95919d7c3d0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree",
        "public_id": "019dbb5d-0b1a-756f-8b57-f95919d7c3d0",
        "storage_key": "property/6767906449167382/019dbb5d-0b1a-756f-8b57-f95919d7c3d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7chdE-j0OIgRvbWMowoY3rE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_999f9ab1-9f5a-4556-ad4a-ac5469e0d837",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Conservatory Building",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1777 E Broad St, Columbus, OH 43205, USA",
      "poi_short_description": "Orchids and butterfly exhibits, along with a botanical garden and outdoor spaces.",
      "poi_long_description": "People say this botanical garden offers beautiful plants, flowers, and exhibits, including a butterfly house, train village, and glass blowing demonstrations. They highlight the peaceful and family-friendly atmosphere, and the fun activities for children. They also like the seasonal events and exhibits, such as the orchid season, holiday lights, and pumpkin aglow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb56-5f9c-7418-b3c6-32cd0c5f80bc.webp",
      "poi_featured_image_media": {
        "alt_text": "Koi pond with colorful floating spheres and lush greenery.",
        "public_id": "019dbb56-5f9c-7418-b3c6-32cd0c5f80bc",
        "storage_key": "property/6767906449167382/019dbb56-5f9c-7418-b3c6-32cd0c5f80bc.webp",
        "width": 1729,
        "height": 3072
      },
      "poi_business_url": "http://www.fpconservatory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3927823492693676560&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "conservatory-building",
      "poi_latitude": "39.9658594",
      "poi_longitude": "-82.9532828",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 858-914-7464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wfqpYuJOIgRENJw9qdugjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_68317cfd-b045-4f48-b849-17a801cd07b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Blendon Woods Metro Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4265 E Dublin Granville Rd, Columbus, OH 43230, USA",
      "poi_short_description": "This 653-acre park offers a waterfowl refuge & a nature center plus disc golf & ice-skating.",
      "poi_long_description": "People say this park offers a disc golf course, walking trails, playgrounds, picnic areas, and a nature center. They highlight the well-maintained trails, the natural play area with a zip line and rope swings, and the inclusive playground for special needs children. They also like the beautiful scenery, the opportunities to view wildlife, and the peaceful atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb56-6b44-77d9-af5c-f5cec576c0db.webp",
      "poi_featured_image_media": {
        "alt_text": "Scenic pond with colorful autumn trees and reflections on a clear day.",
        "public_id": "019dbb56-6b44-77d9-af5c-f5cec576c0db",
        "storage_key": "property/6767906449167382/019dbb56-6b44-77d9-af5c-f5cec576c0db.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.metroparks.net/parksblendonwoods.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4763006684459651558&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blendon-woods-metro-park",
      "poi_latitude": "40.07487",
      "poi_longitude": "-82.8823718",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-620-1861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5d-0b1a-756f-8b57-f95919d7c3d0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree",
        "public_id": "019dbb5d-0b1a-756f-8b57-f95919d7c3d0",
        "storage_key": "property/6767906449167382/019dbb5d-0b1a-756f-8b57-f95919d7c3d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB1uYCGlgOIgR5lEHEliZGUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4f3594f3-e526-4d69-b1df-55e438422d1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "John Glenn Columbus International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4600 International Gateway, Columbus, OH 43219, USA",
      "poi_short_description": "This regional airport serving Central Ohio features a variety of artwork plus free WiFi.",
      "poi_long_description": "Visitors say this airport is easy to navigate, clean, and has friendly staff. They also highlight the efficient TSA process and convenient rental car shuttle.\n\nSome reviews mention the baggage claim can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb56-3202-74c6-b366-86bbc4b33e66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbb56-3202-74c6-b366-86bbc4b33e66",
        "storage_key": "property/6767906449167382/019dbb56-3202-74c6-b366-86bbc4b33e66.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://flycolumbus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11564402479413093569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-glenn-columbus-international-airport",
      "poi_latitude": "39.9999399",
      "poi_longitude": "-82.8871767",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 614-239-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5d-0b83-77b3-848d-4f3b8cf4c67a.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019dbb5d-0b83-77b3-848d-4f3b8cf4c67a",
        "storage_key": "property/6767906449167382/019dbb5d-0b83-77b3-848d-4f3b8cf4c67a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ486JNBFiOIgRwWQQwcgCfaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_11041623-4593-4b54-9880-dae30a7266e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Concourse B, CMH",
      "poi_type": "Transportation & Transit",
      "poi_address": "3939 International Gateway, Columbus, OH 43219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb55-d30b-764f-b086-0f349cb655f3.webp",
      "poi_featured_image_media": {
        "alt_text": "Airport gate waiting area with Delta Airlines signage.",
        "public_id": "019dbb55-d30b-764f-b086-0f349cb655f3",
        "storage_key": "property/6767906449167382/019dbb55-d30b-764f-b086-0f349cb655f3.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7722567719975822736&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "concourse-b-cmh",
      "poi_latitude": "39.9979343",
      "poi_longitude": "-82.88277409999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5d-0b83-77b3-848d-4f3b8cf4c67a.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019dbb5d-0b83-77b3-848d-4f3b8cf4c67a",
        "storage_key": "property/6767906449167382/019dbb5d-0b83-77b3-848d-4f3b8cf4c67a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47c-rzxiOIgRkKUO52wSLGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_d93fce31-a94e-4f4c-ba8b-6bbf06afc2a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "NetJets Private Boarding Lounge (CMH)",
      "poi_type": "Transportation & Transit",
      "poi_address": "4111 Bridgeway Ave, Columbus, OH 43219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb55-cf1a-7579-a821-6c2506482eb6.webp",
      "poi_featured_image_media": {
        "alt_text": "A black NetJets SUV parked in front of a modern building with a skybridge.",
        "public_id": "019dbb55-cf1a-7579-a821-6c2506482eb6",
        "storage_key": "property/6767906449167382/019dbb55-cf1a-7579-a821-6c2506482eb6.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://www.netjets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18310888535034751606&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "netjets-private-boarding-lounge-cmh",
      "poi_latitude": "40.0069607",
      "poi_longitude": "-82.8997564",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-239-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5d-0b83-77b3-848d-4f3b8cf4c67a.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019dbb5d-0b83-77b3-848d-4f3b8cf4c67a",
        "storage_key": "property/6767906449167382/019dbb5d-0b83-77b3-848d-4f3b8cf4c67a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJDasPsgNiOIgRduqEfBtYHf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3af48f1b-f530-450a-a6fd-5fdc01783dc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Bath & Body Works DC3",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3 Limited Pkwy, Columbus, OH 43230, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb55-ef75-7059-b957-7a0b8441b93f.webp",
      "poi_featured_image_media": {
        "alt_text": "Scenic waterfall cascading over rocks surrounded by lush greenery.",
        "public_id": "019dbb55-ef75-7059-b957-7a0b8441b93f",
        "storage_key": "property/6767906449167382/019dbb55-ef75-7059-b957-7a0b8441b93f.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11719441839784658631&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bath--body-works-dc3",
      "poi_latitude": "40.0543753",
      "poi_longitude": "-82.89689500000001",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-415-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ78jKI0tkOIgRxwY30kLSo6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d590b8fe-f4de-4e4b-8f10-46487c586008",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "NetJets Global Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4151 Bridgeway Ave, Columbus, OH 43219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb56-dd3c-733a-8464-8eab42f87984.webp",
      "poi_featured_image_media": {
        "alt_text": "NetJets building exterior with signage",
        "public_id": "019dbb56-dd3c-733a-8464-8eab42f87984",
        "storage_key": "property/6767906449167382/019dbb56-dd3c-733a-8464-8eab42f87984.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://netjets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5562378476595858639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "netjets-global-headquarters",
      "poi_latitude": "40.0064832",
      "poi_longitude": "-82.89748709999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-239-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJayZuRQJiOIgRz0zG88CJMU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_73c41ee0-0107-467a-8897-f17c6bf7a79b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Rogue Fitness",
      "poi_type": "Major Employers & Offices",
      "poi_address": "545 E 5th Ave, Columbus, OH 43201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb56-ba2c-759e-a462-1094b3e50ada.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a spacious gym with artificial turf, weightlifting racks, and various flags hanging from the ceiling.",
        "public_id": "019dbb56-ba2c-759e-a462-1094b3e50ada",
        "storage_key": "property/6767906449167382/019dbb56-ba2c-759e-a462-1094b3e50ada.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.roguefitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14904095947221728010&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rogue-fitness",
      "poi_latitude": "39.985279",
      "poi_longitude": "-82.990151",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 614-358-6190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-_EOwzKJOIgRCnt9eEz81c4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b4479527-a874-4599-a259-0dea21cb9174",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "Bread Financial",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3095 Loyalty Cir, Columbus, OH 43219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb56-1dec-754f-8593-62c3f1a8ef6f.webp",
      "poi_featured_image_media": {
        "alt_text": "Bread Financial logo on the exterior of a building.",
        "public_id": "019dbb56-1dec-754f-8593-62c3f1a8ef6f",
        "storage_key": "property/6767906449167382/019dbb56-1dec-754f-8593-62c3f1a8ef6f.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://www.breadfinancial.com/?utm_source=local_listing&utm_medium=organic&utm_campaign=breadfinancial_easton",
      "poi_directions_map_url": "https://maps.google.com/?cid=4443722468892373177&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bread-financial",
      "poi_latitude": "40.0353831",
      "poi_longitude": "-82.9144615",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 614-729-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaXzHV3GKOIgRuXDApgpGqz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7a428c78-5498-467f-ba7f-b96ae2157424",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "poi_name": "LBrands DC6",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3425 Morse Crossing, Columbus, OH 43219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb56-5a93-7607-8551-1a0b29084e63.webp",
      "poi_featured_image_media": {
        "alt_text": "People walking in front of the Palace of Westminster and Big Ben in London.",
        "public_id": "019dbb56-5a93-7607-8551-1a0b29084e63",
        "storage_key": "property/6767906449167382/019dbb56-5a93-7607-8551-1a0b29084e63.webp",
        "width": 3072,
        "height": 2307
      },
      "poi_business_url": "http://careers.victoriassecret.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14725932231350289403&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lbrands-dc6",
      "poi_latitude": "40.046405",
      "poi_longitude": "-82.924409",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dbb5c-ecf9-71bd-a032-6bd83800762a",
        "storage_key": "property/6767906449167382/019dbb5c-ecf9-71bd-a032-6bd83800762a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZMRbmCLOIgR-wMc1FcFXcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_89e42bd0-ef50-4f1a-8539-8d2358f44c01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_5e428521-e557-4487-8933-9b88b34e07f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_53859d7d-b791-4f86-b7f1-1b68a807495a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_2dd3a6b5-9a93-48e8-9287-d70f49f24fdc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_b9b4b880-dd7e-4f60-9a61-ababccd28af4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1c754288-e0ff-4c6b-87ae-20817c51b11c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "rating": "5.0",
      "name": "C Byers",
      "text": "Great apartment for the price. A fireplace and a detached garage in one bedroom townhouse is hard to come by at such a bargain. The neighbors keep to themselves and never to much noise around. I truly enjoyed living here.",
      "date": "2013-01-12",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_ae6a9ec7b6ae8167d8169038",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb9e-5288-7663-9f66-eb00ecb5aac2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019dbb9e-5288-7663-9f66-eb00ecb5aac2",
        "storage_key": "property/6767906449167382/019dbb9e-5288-7663-9f66-eb00ecb5aac2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 670 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gWKnUTxHpMB"
    },
    {
      "id": "ec_300185a9ba382242b1edd3c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb9e-5298-733d-b852-ce031ac5a8f1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019dbb9e-5298-733d-b852-ce031ac5a8f1",
        "storage_key": "property/6767906449167382/019dbb9e-5298-733d-b852-ce031ac5a8f1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 970 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DeKD7u3MEQn"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e1ddc-b2a7-7579-ac9d-ea5cb4d90858",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "wsp---woodside-place-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382"
    },
    {
      "lead_collector_id": "019e1ddc-b318-772f-a380-ea5d85029f01",
      "lead_source": "FACEBOOK_ADS",
      "name": "wsp---woodside-place-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382"
    },
    {
      "lead_collector_id": "019e1ddc-b388-77b5-9858-8aa7d886f61a",
      "lead_source": "LANDING_PAGE",
      "name": "wsp---woodside-place-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "washer-dryer-hookups-apartments-gahanna-oh",
      "search_query": "washer dryer hookups apartments in Gahanna OH",
      "category": "Amenity",
      "h1_title": "Washer Dryer Hookups Apartments in Gahanna",
      "h2_subtitle": "Discover convenience with our apartments offering washer dryer hookups in Gahanna, OH. Woodside Place Apartments ensures your comfort with in-unit amenities.",
      "page_copy": "At Woodside Place Apartments in Gahanna, OH, enjoy the perfect fusion of convenience and comfort with our washer dryer hookups right inside your home. Whether you opt for our spacious one or two-bedroom floor plans, each apartment features these in-unit amenities to enhance your living experience. Coupled with private entrances and stylish bay windows, our homes are designed with your lifestyle in mind. \n\nBeyond the convenience of in-unit washer dryer hookups, residents can relish various other amenities such as beautifully landscaped grounds, a volleyball court, and a smart card system for added convenience. Situated in the charming neighborhood of Wexmoor, Woodside Place Apartments is more than just a residence—it's your next home, complete with everything you need for the ultimate living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer Dryer Hookups Apts in Gahanna, OH",
      "seo_description": "Find washer dryer hookups at Woodside Place Apartments in Gahanna, OH. Enjoy comfort with in-unit amenities and modern features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-franklin-county-oh",
      "search_query": "air conditioned apartments in Franklin County OH",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Franklin County",
      "h2_subtitle": "Experience year-round comfort in Franklin County, OH with air-conditioned apartments. Discover how Woodside Place Apartments keeps you cool.",
      "page_copy": "Woodside Place Apartments, located in charming Gahanna within Franklin County, OH, welcomes you with the comfort of air-conditioned living spaces. Available in both one and two-bedroom options, these apartments ensure you stay cool during hot summer months, providing an escape from the heat and a cozy haven year-round. \n\nOur community not only offers air-conditioned units, but also features such as stylish bay windows and private entrances. Residents can enjoy beautifully landscaped grounds and a volleyball court, all while benefiting from amenities like in-unit washers and 24-hour emergency maintenance. With everything at your fingertips, Woodside Place Apartments is the ideal choice for those seeking air-conditioned apartments in Franklin County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apts in Franklin County, OH",
      "seo_description": "Stay cool at Woodside Place Apartments in Franklin County, OH. Enjoy air conditioned comfort and modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "apartments-private-entrances-wexmoor",
      "search_query": "apartments with private entrances in Wexmoor",
      "category": "Amenity",
      "h1_title": "Apartments with Private Entrances in Wexmoor",
      "h2_subtitle": "Enjoy privacy with our Wexmoor apartments featuring private entrances. Discover the convenience at Woodside Place Apartments.",
      "page_copy": "Nestled in the delightful Wexmoor neighborhood, Woodside Place Apartments offers a serene living experience with the added benefit of private entrances. Our thoughtfully designed one and two-bedroom apartments in Wexmoor provide residents with their own exclusive entryway, ensuring an added level of privacy and comfort. \n\nBeyond private entrances, our community boasts stylish bay windows and finished basements that add a touch of elegance to every home. Residents can also indulge in the beauty of our landscaped grounds or challenge friends on our volleyball court. Conveniently located, Woodside Place Apartments is the ultimate choice for those seeking a private living experience in the heart of Wexmoor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Private Entrances in Wexmoor",
      "seo_description": "Discover privacy at Woodside Place Apartments in Wexmoor, featuring private entrances and modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "dishwasher-equipped-apartments-43230",
      "search_query": "dishwasher equipped apartments in 43230",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments in 43230",
      "h2_subtitle": "Find convenience in Gahanna, OH's 43230 area with dishwasher equipped apartments. Discover the ease at Woodside Place Apartments.",
      "page_copy": "Located within the 43230 ZIP code of Gahanna, OH, Woodside Place Apartments offers the convenience of dishwasher-equipped homes. Our one and two-bedroom apartments come with a full suite of modern amenities, ensuring that daily chores are more manageable and leaving you with more time to enjoy the perks of our vibrant community.\n\nBeyond the convenience of dishwashers, our apartments feature private entrances, air conditioning, and stylish bay windows. Residents enjoy access to beautifully landscaped grounds, a volleyball court, and 24-hour emergency maintenance. Situated in a prime location, Woodside Place Apartments provides the perfect blend of comfort and practicality in the heart of Gahanna.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Apartments in 43230 Gahanna, OH",
      "seo_description": "Explore dishwasher equipped apartments in Gahanna's 43230. Woodside Place offers convenience and modern living for all.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-gahanna-oh",
      "search_query": "one bedroom apartments in Gahanna OH",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Gahanna, OH",
      "h2_subtitle": "Explore one bedroom apartments in Gahanna, OH at Woodside Place. Embrace comfort and style in a vibrant community setting.",
      "page_copy": "Discover the perfect one bedroom apartment at Woodside Place Apartments, located in the heart of Gahanna, OH. Our thoughtfully designed one-bedroom layouts provide ample living space, featuring private entrances and stylish bay windows that invite natural light into your home.\n\nAt Woodside Place, convenience is key. Each apartment comes equipped with modern amenities including air conditioning and a dishwasher, while residents can also enjoy the beautifully landscaped grounds and a fun volleyball court. Situated in a prime Gahanna location, our community offers a comfortable and vibrant living experience for those seeking a charming one bedroom apartment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apts in Gahanna, OH",
      "seo_description": "Find charming one bedroom apartments in Gahanna, OH at Woodside Place, featuring modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-franklin-county",
      "search_query": "two bedroom apartments Franklin County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Franklin County",
      "h2_subtitle": "Experience spacious living in Franklin County with our two bedroom apartments. Discover comfort at Woodside Place Apartments.",
      "page_copy": "Woodside Place Apartments in Gahanna, OH offers spacious two bedroom apartments nestled in Franklin County. Our thoughtfully designed layouts provide generous living space and include finished basements and stylish bay windows for added comfort and functionality.\n\nEnjoy the convenience of modern amenities with in-unit washers, air conditioning, and private entrances. Beyond your home, residents can take advantage of beautifully landscaped grounds and a volleyball court. Located in a desirable area of Franklin County, Woodside Place Apartments combines comfort and convenience for a well-rounded living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apts in Franklin County, OH",
      "seo_description": "Explore spacious two bedroom apartments in Franklin County at Woodside Place Apartments, offering modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "apartments-near-otterbein-university-gahanna",
      "search_query": "apartments near Otterbein University Gahanna",
      "category": "School",
      "h1_title": "Apartments Near Otterbein University Gahanna",
      "h2_subtitle": "Discover convenient apartment living near Otterbein University at Woodside Place in Gahanna. ",
      "page_copy": "Woodside Place Apartments in Gahanna, OH offers a convenient location near Otterbein University, making it a great option for those seeking easy access to campus. Our community provides a balance of comfort and accessibility, with spacious one and two-bedroom layouts featuring private entrances and modern amenities like in-unit washers and stylish bay windows.\n\nResidents enjoy beautifully landscaped grounds and onsite amenities such as a volleyball court, supporting an active and relaxed lifestyle. With quick access to local destinations and surrounding areas, Woodside Place Apartments delivers a well-rounded living experience in Gahanna, OH.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Otterbein University Gahanna, OH",
      "seo_description": "Find convenient apartments near Otterbein University at Woodside Place in Gahanna, OH. ",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "ohio-dominican-university-nearby-apartments-franklin-county",
      "search_query": "Ohio Dominican University nearby apartments Franklin County",
      "category": "School",
      "h1_title": "Nearby Apartments to Ohio Dominican University",
      "h2_subtitle": "Discover nearby apartments to Ohio Dominican University in Franklin County at Woodside Place. Enjoy convenience in a friendly community.",
      "page_copy": "Woodside Place Apartments offers comfortable living near Ohio Dominican University in Franklin County, providing convenient access to campus and surrounding destinations. Our one and two-bedroom layouts are thoughtfully designed to support a variety of lifestyles, featuring private entrances and stylish bay windows.\n\nResidents enjoy modern in-home features including in-unit washers and air conditioning, along with access to beautifully landscaped grounds. With its convenient location and well-rounded amenities, Woodside Place Apartments provides a comfortable and accessible living experience in Gahanna, OH.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apts to Ohio Dominican Univ Franklin OH",
      "seo_description": "Explore nearby apartments in Franklin County close to Ohio Dominican University at Woodside Place. ",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "apartments-near-franklin-park-conservatory-gahanna",
      "search_query": "apartments near Franklin Park Conservatory Gahanna",
      "category": "Park",
      "h1_title": "Apartments Near Franklin Park Conservatory",
      "h2_subtitle": "Explore living close to Franklin Park Conservatory in Gahanna at Woodside Place Apartments. Enjoy a serene lifestyle near natural beauty.",
      "page_copy": "Nestled in the scenic area of Gahanna, OH, Woodside Place Apartments offers the perfect living experience near the Franklin Park Conservatory. Our spacious one and two-bedroom units, featuring stylish bay windows and private entrances, are just a short drive from this beautiful local attraction.\n\nExperience the tranquility of our beautifully landscaped grounds and make use of amenities such as in-unit washers and a volleyball court. Living at Woodside Place Apartments means not only residing in high comfort but also enjoying easy access to the serene natural beauty of Franklin Park Conservatory. Discover a harmonious blend of relaxation and convenience that enhances your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Franklin Park Conservatory Gahanna",
      "seo_description": "Find apartments near Franklin Park Conservatory in Gahanna at Woodside Place. Enjoy spacious living with easy access to local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "wexmoor-apartments-close-to-inniswood-metro-gardens",
      "search_query": "Wexmoor apartments close to Inniswood Metro Gardens",
      "category": "Park",
      "h1_title": "Wexmoor Apartments Near Inniswood Gardens",
      "h2_subtitle": "Discover Wexmoor apartments conveniently located close to Inniswood Metro Gardens. Enjoy nature and comfort at Woodside Place.",
      "page_copy": "Located in the charming Wexmoor neighborhood, Woodside Place Apartments offers an exceptional living experience just minutes from the serene Inniswood Metro Gardens. Our community features thoughtfully designed one and two-bedroom apartments with amenities such as private entrances and stylish bay windows.\n\nThe beautifully landscaped grounds and a range of modern amenities, including in-unit washers and a volleyball court, enhance the living experience at Woodside Place. This prime location not only provides access to the vibrant natural beauty of Inniswood Metro Gardens but also ensures convenience and comfort, making it a top choice for those who appreciate both urban amenities and outdoor adventures.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wexmoor Apts Near Inniswood Metro Gardens",
      "seo_description": "Explore Wexmoor apartments near Inniswood Metro Gardens at Woodside Place. Enjoy modern living in a natural setting with easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "gahanna-apartments-by-conservatory-building",
      "search_query": "Gahanna apartments by Conservatory Building",
      "category": "Park",
      "h1_title": "Gahanna Apartments by Conservatory Building",
      "h2_subtitle": "Experience the convenience of living in Gahanna apartments near the Conservatory Building. Woodside Place offers comfort and accessibility.",
      "page_copy": "Woodside Place Apartments in Gahanna, OH, offers an ideal location for those looking to reside near the Conservatory Building. Our community provides spacious one and two-bedroom apartments, each with private entrances and charming bay windows that bring in plenty of natural light.\n\nIn addition to lovely living spaces, residents enjoy convenient amenities like in-unit washers, air conditioning, and access to beautifully landscaped grounds. Located near the Conservatory Building, these apartments allow quick access to vibrant culture and recreational options while ensuring a peaceful residential environment. Make Woodside Place Apartments your new home and enjoy the best of Gahanna living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gahanna Apartments Near Conservatory Building",
      "seo_description": "Discover Gahanna apartments near the Conservatory Building at Woodside Place. Enjoy spacious, modern living with quick access to local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167382",
      "source": "custom",
      "page_item_url": "franklin-county-apartments-near-blendon-woods-metro-park",
      "search_query": "Franklin County apartments near Blendon Woods Metro Park",
      "category": "Park",
      "h1_title": "Franklin County Apartments by Blendon Woods",
      "h2_subtitle": "Live in Franklin County near Blendon Woods Metro Park. Woodside Place Apartments offers comfort and natural beauty for your lifestyle.",
      "page_copy": "Experience serene living in Franklin County with Woodside Place Apartments, conveniently located near Blendon Woods Metro Park. Choose from spacious one and two-bedroom layouts featuring elegant bay windows and private entrances, perfect for those who appreciate both comfort and proximity to nature.\n\nOur community is designed with modern amenities such as in-unit washers and a volleyball court, ideal for an active lifestyle. The beautifully landscaped grounds offer a peaceful retreat, while the nearby Blendon Woods Metro Park provides endless outdoor exploration opportunities. Embrace a harmonious blend of convenience and nature at Woodside Place Apartments in Gahanna, OH.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, and stairs leading to the second floor.",
        "public_id": "019dc021-df4c-76b8-99db-de0cd0b2de95",
        "storage_key": "property/6767906449167382/019dc021-df4c-76b8-99db-de0cd0b2de95.webp",
        "width": 1190,
        "height": 794
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Franklin County Apts Near Blendon Woods Park",
      "seo_description": "Find Franklin County apartments near Blendon Woods Metro Park at Woodside Place. Enjoy spacious living and nature's beauty in Gahanna, OH.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6187"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11680118679"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4984628"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PPGH2RMV"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_realpage_tour_widget",
      "type": "STRING",
      "value": "<script src=\"https://cs-cdn.realpage.com/CAL/v1.0/cs-calendar-widget.min.js\"></script> <script>var calendar = new csCalendar(\"408488132760\")</script>"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlFZOGtXOTBYaUJGSER3VTJUMGh4bnc9PSIsInZhbHVlIjoieTlMd3dQTnJBMUp4b2ZZOGUvRjRQZz09IiwibWFjIjoiYjllMjNiMWEwNWYzY2U1YWE1ODBkMThlZGZjYjM5NTkyYzUwZjE4Mzk3MDkzZDFkMmQwMzJmZmY4ZDRkN2JkOCJ9"
    }
  ],
  "custom_qb_id": "6187",
  "custom_repli_id": "11680118679",
  "custom_realpage_id": "4984628",
  "custom_google_gtm_id": "GTM-PPGH2RMV",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Preferred",
  "custom_realpage_tour_widget": "<script src=\"https://cs-cdn.realpage.com/CAL/v1.0/cs-calendar-widget.min.js\"></script> <script>var calendar = new csCalendar(\"408488132760\")</script>",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlFZOGtXOTBYaUJGSER3VTJUMGh4bnc9PSIsInZhbHVlIjoieTlMd3dQTnJBMUp4b2ZZOGUvRjRQZz09IiwibWFjIjoiYjllMjNiMWEwNWYzY2U1YWE1ODBkMThlZGZjYjM5NTkyYzUwZjE4Mzk3MDkzZDFkMmQwMzJmZmY4ZDRkN2JkOCJ9",
  "custom_audioeye_site_id": "b2e9e20a-2db6-43cf-b3c5-7c5d944fe997",
  "custom_audioeye_site_hash": "4e95f59d64cab0951c21d4bc06addf34"
};

export const generatedAt = '2026-09-02T15:53:03.164Z';
